import ArticlesPage, { getServerSideProps as defaultGetServerSideProps } from '..'

export const getServerSideProps = defaultGetServerSideProps

export default ArticlesPage
